export default {
  save() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (const [key, value] of Object.entries(this.uploaded_files)) {
        this.data[key] = value;
      }
    }
    this.saveLR(this.data);
  },
};
